<template>
  <div
    class="auth-page min-h-screen relative w-full bg-center-top bg-no-repeat bg-cover text-center pb-4 sm:pb-20"
  >
    <div class="py-5">
      <img alt="startup ACT" class="startup-auth-logo" src="../../assets/img/header-auth-space.svg" />
    </div>

    <div
      class="wrap-login w-68 sm:w-75 max-w-full bg-white shadow-lg rounded-sm p-5 mx-auto"
    >
      <h2
        class="text-2xl font-bold leading-normal text-red uppercase border-b-2 border-red-lighter p-5 mb-4"
      >
        {{ $t("auth.forgot_password") }}
      </h2>

      <div
        class="border border-green text-green px-4 py-3 mb-4 rounded"
        v-if="notice"
      >
        <div class="relative error-messages block sm:inline text-left p-0">
          {{ $t(notice) }}
        </div>
      </div>
      <div
        v-if="errors"
        class="bg-red-lighter border border-red-light text-red-dark text-sm px-4 py-3 mb-4 rounded relative"
        role="alert"
      >
        <ul class="error-messages block sm:inline text-left p-0 list-reset">
          <li v-for="(v, k) in errors" :key="k" class="mx-2">
            <span v-if="v.message">{{ v.message }}</span>
          </li>
        </ul>
      </div>

      <form class="form-app form-forgot-password" autocomplete="off" @submit.prevent="submit">
        <div class="form-group">
          <sp-input
          theme="default"
            name="email"
            placeholder="Email"
            type="text"
            v-model="email"
          ></sp-input>
        </div>

        <div class="text-center">
          <sp-button theme="primary" space="normal" class="w-full uppercase" :class="disabled_class" type="submit">{{
            $t("auth.reset_password")
          }}</sp-button>
        </div>
      </form>

      <div
        class="flex items-center justify-center border-t border-blue-lighter pt-5 pb-2"
      >
        <sp-link
          theme="warning"
          class="inline-block mr-2 no-underline font-bold text-blue hover:text-blue-dark"
          :to="{ name: 'login' }"
          >{{ $t("auth.login") }}</sp-link
        >
        /
        <sp-link
          theme="warning"
          class="inline-block ml-2 no-underline font-bold text-red hover:text-red-light"
          to="register"
          >{{ $t("auth.sing_up") }}</sp-link
        >
      </div>
    </div>


    <footer
      class="flex items-center justify-between text-grey-darker bg-grey-lighter absolute md:absolute pin-b pin-l invisible md:visible w-full py-1 px-3 transition-all"
    >
      <div class="flex items-center">
        <img
          class="mh-8 mx-2"
          alt="Ministère des Technologies de la Communication et de la Transformation Digitale"
          src="../../assets/img/drapeau.png"
        />
        <span class=" text-xxs opacity-60"
          >{{ $t('auth.ministry') }}</span
        >
      </div>
      <div class="sm:w-70 w-60 text-right text-xs">
        {{ $t('auth.technology_by') }} <a class="inline-block text-sm font-bold no-underline cursor-pointer transition-all text-grey-darker hover:text-grey-darker" href="https://www.satoripop.com/" target="_blank">satoripop</a>
      </div>
    </footer>
    
  </div>
</template>

<style></style>

<script>
import { mapState } from "vuex";
import { FORGOT_PASSWORD, CLEAR_ERROR } from "@/store/actions.type";

import Link from "@/components/spKit/Link.vue";
import Button from "@/components/spKit/Button.vue";
import Input from "@/components/spKit/Input.vue";

export default {
  name: "ForgotPassword",
  components: {
    "sp-link": Link,
    "sp-button": Button,
    "sp-input": Input
  },
  data() {
    return {
      email: "",
      error1: "",
      notice: "",
      disabled_class : "",
    };
  },
  methods: {
    submit() {
      this.$Progress.start();
      this.disabled_class = "opacity-50 cursor-not-allowed";
      this.notice = "";
      this.$store
        .dispatch(FORGOT_PASSWORD, {
          email: this.email
        })
        .then(() => {
          this.$Progress.finish();
          this.disabled_class = "";
          this.submitSuccessful();
        });
    },
    submitSuccessful() {
      this.notice = "auth.forget_passowrd_success";
      this.$store.dispatch(CLEAR_ERROR);
      this.email = "";
    }
  },
  watch:{
    errors(){
       this.$Progress.fail();
       this.disabled_class = "";
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
